import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { Button } from 'reactstrap'
import Pricing from '../../components/subcription/pricing'
import { stripeCancelSubscription } from '../../api/stripe'

export default function DashboardSubscription () {
  const account = useSelector(state => state.accountReducers.account)
  const [loading, setLoading] = useState(false)

  const cancelSubscription = async () => {
    setLoading(true)
    await stripeCancelSubscription(account.id)
    setLoading(false)
    toast.success('Subscription cancelled :(')
  }

  return (
    <>
      {account.metadata.premium &&
        <div className="subscription-page-content">
          <p className="py-3">You are currently subscribed to the premium plan.</p>
          <Button onClick={() => cancelSubscription()} disabled={loading}>{loading ? 'Cancelling...' : 'Cancel subscription'}</Button>
        </div>
      }
      {!account.metadata.premium &&
        <div className="subscription-page-content">
          <Pricing
            successUrl="dashboard"
            cancelUrl="dashboard/subscription"
          />
        </div>
      }
    </>
  )
}
